<template>
  <div v-if="langs" class="langs-wrapper">
    <button v-for="(item, index) in langs" :key="index" type="button" class="lang-btn">
      <a
        :href="item.url"
        :title="item.name"
        class="switch_language"
      >{{ item.slug }}</a>
    </button>
  </div>
</template>

<script>
export default {
  name: "fcwpSpecials",
  props: ["langs"],
  methods: {
    eventEmitter(method, value) {
      this.$root.$emit(method, value);
    },
  }
};
</script>

<style scoped lang="scss">

  .lang-btn {
    // top: 185px;
    width: 40px;
    position: relative;
    padding: 0px 5px 3px 5px;
    display: block;
    margin-top: 10px;
    border-radius: 0px 7px 7px 0px;
    left: -1.17vw;
    z-index: 99999;
    background: rgba($primary-color, 0.6);
    font-size: 22pt;
    a {
      padding: 0;
      color: rgb($quaternary-color);
    }
  }

.jumbotron-image, .jumbotron-video {

  .lang-btn {
    left: 0;
    background: rgb(var(--color-primary));
  }
}
</style>